import React, { useState, useEffect } from 'react';
import { Container, Row, Spinner } from 'reactstrap';
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";

import Breadcrumbs from "components/Common/Breadcrumb";
import Overview from './Overview';
import DetailsSection from './DetailsSection';
import DocumentPreviewModal from "./DocumentPreviewModal";
import { ToastContainer } from "react-toastify";

import { 
    getStudentByUuid as onGetStudentByUuid,
    getStudyLevels as onGetStudyLevels,
    //getAcademicYears as onGetAcademicYears,
} from "../../../../store/actions";

const StudentDetails = () => {
    document.title = "Détails étudiant | CinzanEdu";
    const { uuid } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { student, loading } = useSelector(state => state.studentReducer);

    const [file, setFile] = useState(null);
    const [open, setOpen] = useState(false);

    // Selector study levels
    const StudyLevelProperties = createSelector(
        (state) => state.studyLevelReducer, 
        (studyLevelReducer) => ({
            studyLevels: studyLevelReducer.studyLevels,
            loading: studyLevelReducer.loading,
            
        })
    );

    const {studyLevels} = useSelector(StudyLevelProperties);

    // Chargement initial des données
    useEffect(() => {
        if (!studyLevels.length) dispatch(onGetStudyLevels());
       
    }, [dispatch, studyLevels.length]);

    

    useEffect(() => {
        if (uuid) dispatch(onGetStudentByUuid(uuid));
    }, [uuid, dispatch]);

    const openPreview = (file) => {
        setFile(file);
        setOpen(true);
    };

    if (loading || !student) {
        // Affiche un loader tant que l'étudiant n'est pas chargé
        return (
            <Container fluid className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
                <Spinner color="primary" />
            </Container>
        );
    }

    return (
        <>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Étudiant" breadcrumbItem="Détails" />
                    <Row>
                        <DetailsSection student={student} />
                        <Overview
                            student={student}
                            onPreview={openPreview}
                        />
                    </Row>
                </Container>
            </div>

            <DocumentPreviewModal
                isOpen={open}
                toggle={() => setOpen(false)}
                file={file}
            />

            <ToastContainer />
        </>
    );
};

export default StudentDetails;
